<template>
  <div class="header">
    <div class="header__content">
      <img
        class="header__logo"
        :src="logo"
      />
      <app-i18n-select class="header__i18n" />
    </div>
  </div>
</template>

<script>
import owqloLogo from '@/assets/logo-owqlo.svg'

import AppI18nSelect from '@shared/i18n-utils/i18n-select.vue'

export default {
  name: 'appHeader',
  data() {
    return {
      logo: owqloLogo,
    }
  },
  components: {
    AppI18nSelect,
  },
}
</script>

<style lang="scss" scoped>
.header {
  height: 72px;
  box-shadow: 0 2px 10px 0 rgba(51, 51, 51, 0.1);
  background-color: #ffffff;
  display: flex;

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 0 24px;
  }

  &__logo {
    width: auto;
    height: 24px;

    @include tablet {
      height: 32px;
    }
  }
}
</style>